import fetch from 'unfetch'

export function Client ({ urls }) {
  return { venues }

  function venues ({ term, startOn, endOn, top, left, bottom, right }) {
    const params = {
      term,
      start_on: startOn,
      end_on: endOn,
      sw_lat: top,
      sw_lng: left,
      ne_lat: bottom,
      ne_lng: right
    }
    const url = urls.venues(params)

    return fetch(url).then(r => r.json())
  }
}
